import { useCallback } from "react";
import { initUserState, setUserStore, useUserStore } from "stores/userStore";
import type { UserInfo } from "types/user";

const useUser = () => {
  const { isSignedIn, user } = useUserStore();

  const setUser = useCallback((newUser: UserInfo | null) => {
    if (newUser)
      setUserStore((prev) => ({
        ...prev,
        isSignedIn: true,
        user: { ...newUser },
      }));
  }, []);

  const initUserStore = useCallback(() => {
    setUserStore(initUserState());
  }, []);

  return { isSignedIn, user, setUser, initUserStore };
};

export default useUser;
